import { useEffect } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable } from "../../../Hooks/NoDataFoundTable";
import Pagination from "../../../Hooks/Pagination";
import { categoryServices } from "../../../APIServices/GlobalManagement/BlogManagement/categoryServices";
import Swal from "sweetalert2";
import { FaTrashAlt } from "react-icons/fa";

const DeletedBlogCategory = ({
  deletedBlogCategory,
  softDeleteRestoreBlogCategory,
  Show,
  Hide,
  Title,
  getDeletedBlogCategoryList,
  deletedBlogCategoryCount,
  pageNumberDeleted,
  itemsPerPageDeleted,
  setPageNumberDeleted,
  setItemsPerPageDeleted,
}) => {
  const startIndex = (pageNumberDeleted - 1) * itemsPerPageDeleted;
  const totalPage = Math.ceil(deletedBlogCategoryCount / itemsPerPageDeleted);

  const deleteBlogCategory = async (categoryId) => {
      Swal.fire({
        title: "Are you sure?",
        text: `You want to permanent delete category?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, permanent delete it!`,
      }).then(async (result) => {
        if (!result.isConfirmed) return;
        const userData = {categoryId};
        const data = await categoryServices.deleteBlogCategory(userData);
        if (data?.statusCode === 200) {
          getDeletedBlogCategoryList()
        }
      });
    };

  useEffect(() => {
    getDeletedBlogCategoryList(pageNumberDeleted, itemsPerPageDeleted);
  }, [pageNumberDeleted, itemsPerPageDeleted]);
  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 600 }}
        placement="end"
      >
        <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
          <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {deletedBlogCategoryCount === 0 ? (
            <NoDataFoundTable MSG={"No Category."} />
          ) : (
            <>
              <Table bordered striped hover>
                <thead className="position-sticky top-0">
                  <tr>
                    <th
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th>Name</th>
                    <th
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                    <th
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {deletedBlogCategory?.map((item, index) => (
                    <tr key={index} title="View Details">
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td>{item?.name}</td>
                      <td className="text-center" title="Restore">
                        <MdRestore
                          style={{ fontSize: 16 }}
                          onClick={(e) =>
                            softDeleteRestoreBlogCategory(
                              item?.categoryId,
                              "restore"
                            )
                          }
                          className="text-success CP"
                        />
                      </td>
                      <td className="text-center" title="Permanent Delete">
                        <FaTrashAlt
                          style={{ fontSize: 13 }}
                          onClick={(e) =>
                            deleteBlogCategory(item?.categoryId)
                          }
                          className="text-danger CP"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumberDeleted}
                  itemsPerPage={itemsPerPageDeleted}
                  totalItems={deletedBlogCategoryCount}
                  setPageNumber={setPageNumberDeleted}
                  setItemsPerPage={setItemsPerPageDeleted}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedBlogCategory;
